import purefn from './purefn';
import datefn from './datefn';
import uface from './uface';
import Request from './core/request/Request';
import aider from './aider';

const widget = Object.assign({}, purefn, datefn, uface, Request, aider);
export { widget as default, purefn, datefn, uface, Request, aider };
